import { ERR_OFFERING, GET_OFFERINGS, GET_EXPIRING_OFFERS, LOADING_OFFERINGS } from "../actions/actionTypes";

const initialState = {
	offerings: [],
	loading: false,
	errors: {},
	expiringOffers: []
};

export default function offeringReducer(state = initialState, action) {
	const { type, payload } = action;

	switch (type) {
		case GET_OFFERINGS:
			return {
				...state,
				offerings: payload,
				loading: false,
			};
		case GET_EXPIRING_OFFERS:
			return {
				...state,
				expiringOffers: payload,
				loading: false,
			};
		case ERR_OFFERING:
			return {
				...state,
				error: payload,
				loading: false,
				profile: null,
			};
		case LOADING_OFFERINGS:
			return {
				...state,
				loading: payload
			};
		default:
			return state;
	}
}
